import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "common/src/router/compat";
import {
  FooterButton,
  StyledFooterText,
} from "../styledComponents/StyledFooter";
import { StyledMaterialIcon } from "../styledComponents/StyledHeader";

/** CMS footer HTML often uses <td> for the first header row; promote to <th>. */
const ensureTableHeaders = (html) => {
  if (!html || !/<table\b/i.test(html)) return html;

  return html.replace(/<table\b[^>]*>[\s\S]*?<\/table>/gi, (tableHtml) => {
    let rowIndex = 0;
    return tableHtml.replace(/<tr\b[^>]*>[\s\S]*?<\/tr>/gi, (rowHtml) => {
      if (rowIndex++ !== 0 || /<th\b/i.test(rowHtml)) return rowHtml;
      return rowHtml
        .replace(/<td(\s[^>]*)?>/gi, (_, attrs = "") => {
          const withoutScope = attrs.replace(
            /\s*scope\s*=\s*(['"]).*?\1/i,
            "",
          );
          return `<th scope="col"${withoutScope}>`;
        })
        .replace(/<\/td>/gi, "</th>");
    });
  });
};

const PUB_FOOTER_TEXT_LABELS = [
  ["/99royale", "label_footer_text_99royale"],
  ["/livecasino/baccarat", "label_footer_text_livecasino_baccarat"],
  ["/livecasino/blackjack", "label_footer_text_livecasino_blackjack"],
  ["/livecasino/roulette", "label_footer_text_livecasino_roulette"],
  ["/livecasino/poker", "label_footer_text_livecasino_poker"],
  ["/table-games/blackjack", "label_footer_text_table_games_blackjack"],
  ["/table-games/roulette", "label_footer_text_table_games_roulette"],
  ["/table-games", "label_footer_text_table_games"],
  ["/sports-book/sports", "label_footer_text_sportsbook"],
  ["/slots", "label_footer_text_slots"],
  ["/livecasino", "label_footer_text_livecasino"],
  ["/video-slots", "label_footer_text_video_slots"],
  ["/video-poker", "label_footer_text_video_poker"],
];

const FooterText = ({
  skin,
  companyInfo,
  pages = {},
  providerPageKeys = [],
}) => {
  const [expand, setExpand] = useState(false);
  const [expandIcon, setExpendIcon] = useState(false);
  const { t, i18n } = useTranslation("");
  const location = useLocation();

  const getFooterTextLabel = () => {
    const pathname = location.pathname.toLowerCase();

    if (companyInfo) {
      return "label_company_info_footer_text";
    }

    if (skin === "pub") {
      // Most specific first; a missing label falls through to the next match, then to the default
      const pageLabel = PUB_FOOTER_TEXT_LABELS.find(
        ([path, label]) => pathname.includes(path) && i18n.exists(label),
      );
      if (pageLabel) {
        return pageLabel[1];
      }
    }

    const matchedProvider = providerPageKeys.find(
      (key) => pages[key] && pathname === pages[key].toLowerCase(),
    );
    if (matchedProvider) {
      const label = `label_footer_text_${matchedProvider.replace(/-/g, "_")}`;
      console.log(label);
      return i18n.exists(label) ? label : null;
    }

    return "label_footer_text";
  };

  const handleExpend = (e) => {
    e.preventDefault();
    setExpand(!expand);
    setExpendIcon(!expandIcon);
  };

  const footerTextLabel = getFooterTextLabel();
  if (!footerTextLabel) {
    return null;
  }

  return (
    <>
      <StyledFooterText
        expand={expand}
        companyInfo={companyInfo}
        dangerouslySetInnerHTML={{
          __html: ensureTableHeaders(t(footerTextLabel)),
        }}
      >
        {/* <p>
          Pub casino offers a wide range of different live casino tables with
          real dealers and online casino games including live roulette, live
          blackjack, live baccarat, live game shows, video slots, classic slots,
          slingo and video poker. And if you are still not impressed, you can
          try your luck at plenty of games containing a local or progressive
          jackpot that can reach millions of pounds. All our games are developed
          by market leading vendors. Novomatic, Blueprint, Evolution, Netent,
          BigTimeGaming and IGT just to name a few. We are constantly on the
          hunt for new games, categories, and vendors to expand our range of
          games with innovating and the latest games to ensure the best possible
          experience and amusement for our customers.
        </p>
        <p>
          <br />
          Pub Casino is owned and operated by L&amp;L Europe Ltd, Northfields
          App 7, Vjal Indipendenza, Mosta, MST9026, Malta - all rights reserved
          &copy;. L&amp;L Europe Ltd is licensed and regulated by the MGA under
          license number: MGA/B2C/211/2011.
        </p>
        <p>
          <br />
          L&amp;L Europe Ltd is licensed by the British Gambling Commission
          under license number: 38758 for customers resident in Great Britain.
        </p>
        <p>
          <br />
          This is a real money gambling site. Gamble responsibly and only bet on
          what you can afford. For help and support with gambling addiction
          contact Be Gamble Aware on +44 (0)808 8020 133 or visit{" "}
          <a href="www.begambleaware.org">www.begambleaware.org</a>. More
          information can be found on our Responsible Gaming page.
        </p>
        <p>Gambling can be addictive. Please play responsibly.</p> */}
        {/*  <div className="col-xl">
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum
          dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
          incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
          quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
          commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
          velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
          occaecat cupidatat non proident, sunt in culpa qui officia deserunt
          mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur
          adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute
          irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
          fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident,
          sunt in culpa qui officia deserunt mollit anim id est laborum."
        </div> */}
        {/*  <div className="col-xl">
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum
          dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
          incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
          quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
          commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
          velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
          occaecat cupidatat non proident, sunt in culpa qui officia deserunt
          mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur
          adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute
          irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
          fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident,
          sunt in culpa qui officia deserunt mollit anim id est laborum."
        </div> */}
      </StyledFooterText>
      {!companyInfo && (
        <FooterButton onClick={handleExpend}>
          {t("label_expand", "Expand")}
          <StyledMaterialIcon as="span" icon={expandIcon}></StyledMaterialIcon>
        </FooterButton>
      )}
    </>
  );
};

export default FooterText;
